/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal.js";
import { ChainConfig } from "./chain_config.js";
export const protobufPackage = "injective.evm.v1";
function createBaseParams() {
    return {
        evmDenom: "",
        enableCreate: false,
        enableCall: false,
        extraEips: [],
        chainConfig: undefined,
        allowUnprotectedTxs: false,
        authorizedDeployers: [],
        permissioned: false,
    };
}
export const Params = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.evmDenom !== "") {
            writer.uint32(10).string(message.evmDenom);
        }
        if (message.enableCreate === true) {
            writer.uint32(16).bool(message.enableCreate);
        }
        if (message.enableCall === true) {
            writer.uint32(24).bool(message.enableCall);
        }
        writer.uint32(34).fork();
        for (const v of message.extraEips) {
            writer.int64(v);
        }
        writer.ldelim();
        if (message.chainConfig !== undefined) {
            ChainConfig.encode(message.chainConfig, writer.uint32(42).fork()).ldelim();
        }
        if (message.allowUnprotectedTxs === true) {
            writer.uint32(48).bool(message.allowUnprotectedTxs);
        }
        for (const v of message.authorizedDeployers) {
            writer.uint32(58).string(v);
        }
        if (message.permissioned === true) {
            writer.uint32(64).bool(message.permissioned);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.evmDenom = reader.string();
                    break;
                case 2:
                    message.enableCreate = reader.bool();
                    break;
                case 3:
                    message.enableCall = reader.bool();
                    break;
                case 4:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.extraEips.push(longToString(reader.int64()));
                        }
                    }
                    else {
                        message.extraEips.push(longToString(reader.int64()));
                    }
                    break;
                case 5:
                    message.chainConfig = ChainConfig.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.allowUnprotectedTxs = reader.bool();
                    break;
                case 7:
                    message.authorizedDeployers.push(reader.string());
                    break;
                case 8:
                    message.permissioned = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            evmDenom: isSet(object.evmDenom) ? String(object.evmDenom) : "",
            enableCreate: isSet(object.enableCreate) ? Boolean(object.enableCreate) : false,
            enableCall: isSet(object.enableCall) ? Boolean(object.enableCall) : false,
            extraEips: Array.isArray(object?.extraEips) ? object.extraEips.map((e) => String(e)) : [],
            chainConfig: isSet(object.chainConfig) ? ChainConfig.fromJSON(object.chainConfig) : undefined,
            allowUnprotectedTxs: isSet(object.allowUnprotectedTxs) ? Boolean(object.allowUnprotectedTxs) : false,
            authorizedDeployers: Array.isArray(object?.authorizedDeployers)
                ? object.authorizedDeployers.map((e) => String(e))
                : [],
            permissioned: isSet(object.permissioned) ? Boolean(object.permissioned) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        message.evmDenom !== undefined && (obj.evmDenom = message.evmDenom);
        message.enableCreate !== undefined && (obj.enableCreate = message.enableCreate);
        message.enableCall !== undefined && (obj.enableCall = message.enableCall);
        if (message.extraEips) {
            obj.extraEips = message.extraEips.map((e) => e);
        }
        else {
            obj.extraEips = [];
        }
        message.chainConfig !== undefined &&
            (obj.chainConfig = message.chainConfig ? ChainConfig.toJSON(message.chainConfig) : undefined);
        message.allowUnprotectedTxs !== undefined && (obj.allowUnprotectedTxs = message.allowUnprotectedTxs);
        if (message.authorizedDeployers) {
            obj.authorizedDeployers = message.authorizedDeployers.map((e) => e);
        }
        else {
            obj.authorizedDeployers = [];
        }
        message.permissioned !== undefined && (obj.permissioned = message.permissioned);
        return obj;
    },
    create(base) {
        return Params.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseParams();
        message.evmDenom = object.evmDenom ?? "";
        message.enableCreate = object.enableCreate ?? false;
        message.enableCall = object.enableCall ?? false;
        message.extraEips = object.extraEips?.map((e) => e) || [];
        message.chainConfig = (object.chainConfig !== undefined && object.chainConfig !== null)
            ? ChainConfig.fromPartial(object.chainConfig)
            : undefined;
        message.allowUnprotectedTxs = object.allowUnprotectedTxs ?? false;
        message.authorizedDeployers = object.authorizedDeployers?.map((e) => e) || [];
        message.permissioned = object.permissioned ?? false;
        return message;
    },
};
function longToString(long) {
    return long.toString();
}
if (_m0.util.Long !== Long) {
    _m0.util.Long = Long;
    _m0.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
